// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderRequestSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderRequestSearchDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1CardFinderRequestSearchDefaultResponseData.discriminator = undefined;
PharmacyV1CardFinderRequestSearchDefaultResponseData.additionalProperties = false;
PharmacyV1CardFinderRequestSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "requests",
        "baseName": "requests",
        "type": ""
    },
];
//# sourceMappingURL=pharmacyV1CardFinderRequestSearchDefaultResponseData.js.map